// Note: There may be cases where there are temporarily multiple headers on the page simultaneously.
//
// This is specifically the case on the Zoopla mobile codebase (jQuery Mobile). This does AJAX-page transitions
// but the existing page is not removed from the DOM until after the page we're transitioning to has been injected.
// This means the code below  may execute in an environment where there are multiple headers. In that vain, we code
// defensively to apply any DOM updates to all headers on the page.
type ResponseType = {
    data: {
        user: {
            loggedIn: string;
            trackedProperties: TrackedProperties;
        };
    };
};

type TrackedProperties = {
    total: number;
    items: [
        {
            relationship: string;
            property: {
                uprn: string;
            };
        }
    ];
};

export default function myHome() {
    return function () {
        const sessionStorageKey = 'z-bui-component-header-is-logged-in';

        function getHeaders() {
            return [].slice.call(
                document.querySelectorAll('[data-testid="header"]')
            );
        }

        const loggedInCache = {
            get: function () {
                return (
                    window.sessionStorage.getItem(sessionStorageKey) === 'true'
                );
            }
        };

        function getMyHomeAnchor() {
            return [].slice.call(
                document.querySelectorAll('[data-myhome-button]')
            );
        }

        function getMyHomeURL(trackedProperty: TrackedProperties) {
            const trackedPropertyTotal = trackedProperty.total || 0;
            // the API returns MyHome property as the first item as default
            const claimedProperty = trackedProperty.items[0];
            const isMyHome =
                claimedProperty.relationship &&
                (claimedProperty.relationship === 'LANDLORD' ||
                    claimedProperty.relationship === 'HOMEOWNER');

            if (trackedPropertyTotal === 0) {
                window.location.assign('/home-values/');
                return;
            }

            if (isMyHome && claimedProperty.property.uprn) {
                window.location.assign(
                    '/property/uprn/' + claimedProperty.property.uprn + '/'
                );
                return;
            } else {
                window.location.assign('/home-values/');
            }
        }

        function getGraphQLAPI() {
            const host = window.location.hostname;
            if (
                host.indexOf('qa.zoopla') >= 0 ||
                host.indexOf('local.zoopla') >= 0 ||
                host.indexOf('dev.zoopla') >= 0 ||
                host.indexOf('develop.zoopla') >= 0 ||
                host.indexOf('localhost') >= 0
            )
                return {
                    apiUrl: 'https://api-graphql-lambda.integ.zoopla.co.uk/graphql',
                    apiKey: 'q71XbbbNQyeK8t7STsdS31XogDTTvcT1OrnUGYM6'
                };
            return {
                apiUrl: 'https://api-graphql-lambda.prod.zoopla.co.uk/graphql',
                apiKey: '3Vzj2wUfaP3euLsV4NV9h3UAVUR3BoWd5clv9Dvu'
            };
        }

        function init() {
            const { apiUrl, apiKey } = getGraphQLAPI();
            const query =
                '{"query":"query ($offset: Int, $limit: Int) {\\n  user {\\n    trackedProperties (offset: $offset, limit: $limit) {\\n      total\\n      items {\\n        relationship\\n        property {\\n          uprn\\n          }\\n      }\\n    }\\n  }\\n}\\n","variables":{"offset":0,"limit":1}}';
            const headers = getHeaders();

            if (!headers.length) {
                return;
            }

            function onFetchTrackedProperty(response: ResponseType) {
                const isLoggedIn =
                    !!response.data &&
                    !!response.data.user &&
                    !!response.data.user.loggedIn;
                if (!isLoggedIn) {
                    window.location.assign('/home-values/');
                }
                getMyHomeURL(response.data.user.trackedProperties);
            }

            function fetchTrackedProperty(
                callback: typeof onFetchTrackedProperty
            ) {
                if (!loggedInCache.get()) {
                    // get login state from loggedInCache
                    window.location.assign('/home-values/');
                    return;
                }

                const req = new window.XMLHttpRequest();
                req.open('POST', apiUrl, true);
                req.setRequestHeader('X-Api-Key', apiKey);
                req.setRequestHeader('Content-Type', 'application/json');
                req.withCredentials = true;
                req.onreadystatechange = function () {
                    if (req.readyState === XMLHttpRequest.DONE) {
                        try {
                            if (req.status !== 200) {
                                throw Error(
                                    'Error occurred when fetching tracked property. Status code: ' +
                                        req.status +
                                        '.'
                                );
                            }
                            const response = JSON.parse(req.response);
                            if (!response.data) {
                                throw Error(
                                    'Error: data format is not correct.'
                                );
                            }
                            callback(response);
                        } catch (error) {
                            console.error((error as Error).message);
                            window.location.assign('/home-values/');
                        }
                    }
                };
                req.send(query);
            }

            getMyHomeAnchor().forEach(function (btn: HTMLElement) {
                btn.addEventListener('click', function (e: Event) {
                    e.preventDefault();
                    fetchTrackedProperty(onFetchTrackedProperty);
                });
            });
        }

        // Defer the rest if we can until DOMContentLoaded
        if (/complete|interactive|loaded/.test(document.readyState)) {
            init();
        } else {
            document.addEventListener('DOMContentLoaded', init);
        }
    };
}
